






































import { Vue, Component, Prop } from 'vue-property-decorator'
import SearchResultsItemContent from 'components/presenter/search/SearchResultsItemContent.vue'
import SearchResultsStudentGroup from 'components/presenter/search/SearchResultsStudentGroup.vue'
import SearchResultsStudent from 'components/presenter/search/SearchResultsStudent.vue'
import SearchResultsSession from 'components/presenter/search/SearchResultsSession.vue'
import SearchResultsAttendee from 'components/presenter/search/SearchResultsAttendee.vue'
import { SearchResultType } from 'src/graphql/types'

@Component({
  components: {
    SearchResultsItemContent,
    SearchResultsStudentGroup,
    SearchResultsStudent,
    SearchResultsSession,
    SearchResultsAttendee
  }
})
export default class PresenterSearchResultsListItem extends Vue {
  SearchResultType = SearchResultType

  @Prop()
  readonly item!: object
}
